<template>
  <VBtn
      dark
      color="brandingPrimary"
      data-test="loginButton"
      :class="{ 'login-button-xs': $vuetify.breakpoint.xs }"
      @click="$emit('toAuthPage')"
  >
    <span v-if="$vuetify.breakpoint.xs">
          <VIcon>
            mdi-login
          </VIcon>
    </span>
    <span v-else class="button">
      {{ $t('header.login') }}
    </span>
  </VBtn>
</template>

<script lang="ts">
export default {
  name: 'TheLoginButton',
};
</script>

<script setup lang="ts">
</script>

<style scoped lang="scss">
.login-button-xs {
  min-width: unset !important;
  padding: 0 12px !important;
  width: 44px !important;
}
</style>
